<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 3729 3729"
       xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Vrstva_x0020_1">
    <g id="_882453960">
     <path class="fil0"
           d="M1166 1671c16,13 200,300 215,326 70,122 151,260 64,404 -62,103 -225,192 -368,116 -78,-41 -144,-113 -161,-200 -11,-54 -1,-111 14,-160 27,-82 78,-170 116,-246 20,-40 40,-79 59,-119 18,-36 41,-89 61,-121zm-16 -1261c158,-24 288,95 311,224 30,162 -96,290 -229,311 -161,25 -292,-91 -315,-224 -27,-163 100,-290 233,-311zm-126 -407c-226,9 -437,29 -651,74 -235,50 -376,98 -372,357 8,482 2,964 3,1446 1,359 5,722 -1,1080 -3,169 -29,326 169,375 129,33 349,57 481,67 423,30 960,30 1378,-33 167,-26 314,-39 342,-203 9,-53 5,-123 5,-179 -7,-844 -5,-1683 0,-2527 0,-127 -15,-217 -88,-278 -108,-90 -402,-132 -575,-153 -223,-26 -463,-34 -691,-26z"/>
      <path class="fil1"
            d="M1075 2387c-20,-23 -34,-84 -35,-123 -6,-135 97,-219 140,-316 20,8 72,61 86,76 115,125 95,210 41,350 -20,-17 -96,-147 -114,-167 -8,-10 -2,-3 -8,-8l-110 188zm91 -716c-20,32 -43,85 -61,121 -19,40 -39,79 -59,119 -38,76 -89,164 -116,246 -15,49 -25,106 -14,160 17,87 83,159 161,200 143,76 306,-13 368,-116 87,-144 6,-282 -64,-404 -15,-26 -199,-313 -215,-326z"/>
      <path class="fil1"
            d="M1189 485c10,22 21,204 25,255 3,29 9,66 -28,64 -32,-3 -26,-33 -23,-62 6,-65 17,-226 25,-254 0,0 1,-2 1,-3zm-39 -75c-133,21 -260,148 -233,311 23,133 154,249 315,224 133,-21 259,-149 229,-311 -23,-129 -153,-248 -311,-224z"/>
      <path class="fil0" d="M540 3514c16,34 73,77 114,100 244,134 653,145 917,66 107,-31 223,-89 259,-166l-1290 0z"/>
      <path class="fil0"
            d="M1075 2387l110 -188c6,5 0,-2 8,8 18,20 94,150 114,167 54,-140 74,-225 -41,-350 -14,-15 -66,-68 -86,-76 -43,97 -146,181 -140,316 1,39 15,100 35,123z"/>
      <path class="fil0"
            d="M1189 485c0,1 -1,3 -1,3 -8,28 -19,189 -25,254 -3,29 -9,59 23,62 37,2 31,-35 28,-64 -4,-51 -15,-233 -25,-255z"/>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'HeatingTank',
};
</script>

<style scoped>
.fil0 {
  fill: #F69036
}

.fil1 {
  fill: #F7F7F7
}
</style>
